import { Observable } from 'rxjs';
import { InitThreadResponse, PromptResponse, RestoreThreadResponse, SuggestionsResponse } from './endpoint-contracts';

export abstract class AiChatApi {
    public abstract initThread(): Observable<InitThreadResponse>;

    public abstract getSuggestions(threadId: string): Observable<SuggestionsResponse>;

    public abstract restoreThread(threadId: string): Observable<RestoreThreadResponse>;

    public abstract prompt(
        threadId: string | null,
        userMessage: string,
        contextExtras?: Record<string, unknown>
    ): Observable<PromptResponse>;
}
